import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=539b06d6&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=539b06d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b06d6",
  null
  
)

export default component.exports